//submit document
export const GET_FEEDBACK_DOCUMENTS_LIST = "GET_FEEDBACK_DOCUMENTS_LIST"
export const GET_FEEDBACK_DOCUMENTS_LIST_SUCCESS = "GET_FEEDBACK_DOCUMENTS_LIST_SUCCESS"
export const GET_FEEDBACK_DOCUMENTS_LIST_FAILED = "GET_FEEDBACK_DOCUMENTS_LIST_FAILED"

export const SUBMIT_DOCUMENTS_LIST = "SUBMIT_DOCUMENTS_LIST"
export const SUBMIT_DOCUMENTS_LIST_SUCCESS = "SUBMIT_DOCUMENTS_LIST_SUCCESS"
export const SUBMIT_DOCUMENTS_LIST_FAILED = "SUBMIT_DOCUMENTS_LIST_FAILED"